import { render, staticRenderFns } from "./DlvL_List.vue?vue&type=template&id=05840ff1"
import script from "./DlvL_List.vue?vue&type=script&lang=js"
export * from "./DlvL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports